import { authApiService } from '@/api/authApiService';
import { InternalOrganizationUserType } from '@/bundle/_MasterAdmin/types/types';
import { ApiResponseType } from '@/types/sharedTypes';

export const getInternalOrganizationUserDetailsApi = (
  userId: string
): Promise<ApiResponseType<InternalOrganizationUserType>> => {
  const uri = `/organization/internal/users/${userId}/`;

  return authApiService.GET(uri);
};
